import { FC, PropsWithChildren, useMemo } from "react";
import { useParams } from "react-router-dom";
import MriImageUploadsContext from "../../../hooks/context/MriImageUploadsContext";
import useGetIMriImageUploads from "../../../hooks/useGetIMriImageUploads";

export interface IMriImageUploadsProviderProps {
    selectedImagesNotUploaded?: boolean | undefined;
    selectedImagesNotVerified?: boolean | undefined;
    selectedImagesDeidentifiedFailed?: boolean | undefined;
    isCentralReviewer?: boolean;
    canAdministerOpms?: boolean;
    // initial?: GetMriImageUploadsResponse;
}

export const MriImageUploadsProvider: FC<PropsWithChildren<IMriImageUploadsProviderProps>> = ({
    selectedImagesNotUploaded, 
    selectedImagesNotVerified, 
    selectedImagesDeidentifiedFailed,
    isCentralReviewer,
    canAdministerOpms,
    children 
}) => {
    const institutionCode = useParams()?.institutionCode;

    const MriImageUploads = useGetIMriImageUploads(
        institutionCode, 
        selectedImagesNotUploaded, 
        selectedImagesNotVerified, 
        selectedImagesDeidentifiedFailed, 
        { revalidateOnFocus: true, fallbackData: undefined}
    );
    
    const updatedMriImageUploads = useMemo(() => {
        if (!!isCentralReviewer && !canAdministerOpms && MriImageUploads.data) {
            const filteredUploads = MriImageUploads.data?.filter(upload => !!upload.imageDocument?.isVerified || !!upload.cemDocument?.isVerified);
            return {
                ...MriImageUploads,
                data: filteredUploads
            };
        } else {
            return MriImageUploads;
        }
    }, [MriImageUploads, isCentralReviewer, canAdministerOpms]);

    return (
        <MriImageUploadsContext.Provider value={updatedMriImageUploads}>
            {children}
        </MriImageUploadsContext.Provider>
    );
}

export default MriImageUploadsProvider;
